export const languageDictionary = {
  pl: {
    pl: "Polski",
    hu: "Lengyel",
    sk: 'Poľština',
    cs: "Polština",
    en: "Polish",
    ro: "Poloneză",
    et: "Poola",
  },

  en: {
    pl: "Angielski",
    hu: "Angol",
    sk: 'Angličtina',
    cs: "Angličtina",
    en: "English",
    ro: "Engleză",
    et: "Inglise",
  },

  de: {
    pl: "Niemiecki",
    hu: "Német",
    sk: 'Nemčina',
    cs: "Němčina",
    en: "German",
    ro: "Germană",
    et: "Saksa",
  },

  es: {
    pl: "Hiszpański",
    hu: "Spanyol",
    sk: 'Španielčina',
    cs: "Španělština",
    en: "Spanish",
    ro: "Spaniolă",
    et: "Hispaania",
  },

  fr: {
    pl: "Francuski",
    hu: "Francia",
    sk: 'Francúzsky',
    cs: "Francouzština",
    en: "French",
    ro: "Franceză",
    et: "Prantsuse",
  },

  it: {
    pl: "Włoski",
    hu: "Olasz",
    sk: 'Taliančina',
    cs: "Italština",
    en: "Italian",
    ro: "Italiană",
    et: "Itaalia",
  },

  no: {
    pl: "Norweski",
    hu: "Norvég",
    sk: 'Nórsky',
    cs: "Norský",
    en: "Norwegian",
    ro: "Norvegian",
    et: "Norra",
  },

  sv: {
    pl: "Szwedzki",
    hu: "Svéd",
    sk: 'Švédsky',
    cs: "Švédský",
    en: "Swedish",
    ro: "Suedez",
    et: "Rootsi",
  },

  nl: {
    pl: "niderlandzki",
    hu: "Holland",
    sk: 'Holandčina',
    cs: "Nizozemština",
    en: "Dutch",
    ro: "Olandeză",
    et: "Hollandi",
  },

  ru: {
    pl: "Rosyjski",
    hu: "Orosz",
    sk: 'Ruský',
    cs: "Ruština",
    en: "Russian",
    ro: "Rusă",
    et: "Vene",
  },

  cs: {
    pl: "Czeski",
    hu: "Cseh",
    sk: 'Český',
    cs: "Čeština",
    en: "Czech",
    ro: "Cehă",
    et: "Tšehhi",
  },

  sk: {
    pl: "Słowacki",
    sk: 'Slovenský',
    cs: "Slovák",
    en: "Slovak",
    hu: "Szlovák",
    ro: "Slovacă",
    et: "Slovaki",
  },

  sk2: {
    pl: "Słowacki",
    sk: 'Slovenský',
    cs: "Slovák",
    en: "Slovak",
    hu: "Szlovák",
    ro: "Slovacă",
    et: "Slovaki",
  },

  pt: {
    pl: "Portugalski",
    sk: 'Portugalčina',
    cs: "Portugalština",
    en: "Portuguese",
    hu: "Portugál",
    ro: "Portugheză",
    et: "Portugali",
  },

  hu: {
    pl: "Węgierski",
    cs: "Maďarský",
    sk: "Maďarský",
    hu: "Magyar",
    en: "Hungarian",
    ro: "Maghiară",
    et: "Ungari",
  },

  el: {
    pl: "Grecki",
    cs: "Recký",
    sk: "Grécky",
    hu: "Görög",
    en: "Greek",
    ro: "Greacă",
    et: "Kreeka",
  },

  et: {
    pl: "Estoński",
    hu: "Észt",
    sk: "Estónčina",
    cs: "Estonština",
    en: "Estonian",
    ro: "Estoniană",
    et: "Eesti",
  }
};